// extracted by mini-css-extract-plugin
export var footer__max = "Footer-module--footer__max--29Hoe";
export var footer__content = "Footer-module--footer__content--2ofPA";
export var footer__list = "Footer-module--footer__list--2TIyI";
export var footer__item = "Footer-module--footer__item--35gAt";
export var footer__link = "Footer-module--footer__link--3F203";
export var footer__credits = "Footer-module--footer__credits--2nUMj";
export var fadeOutAnimation = "Footer-module--fadeOutAnimation--1dV7m";
export var fadeInAnimation = "Footer-module--fadeInAnimation--1aFN2";